import * as React from "react";
import { useEffect, useState } from "react";

import PropTypes from "prop-types";

// react-router-dom components
import { useNavigate, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";

import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { styled } from "@mui/system";

import Paper from "@mui/material/Paper";
// import DataTable from "Tables/FixturesList";
import DataTable from "Tables/DataTable";
import ActionCell from "../ActionCell";

// sweetalert2 components
import Swal from "sweetalert2";

import { getUserData, getAuthorizationHeader } from "Utils/helpers";
import { getData, postData, delData } from "Utils/server";
import { useSoftUIController } from "context";

const globalCss = require("assets/theme/base/globals");

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 500,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
    marginLeft: "15px",
  },
}));

let loading = false;
function Row(props) {
  const userData = getUserData();
  const [controller, dispatch] = useSoftUIController();
  const { providers } = controller;
  const { rowData, traderView, forceClose } = props;
  const [open, setOpen] = React.useState(false);
  const [fixtures, setFixtures] = useState({
    columns: [
      { Header: "id", accessor: "fixtureId" },
      { Header: "competition", accessor: "league", Cell: wrapWordCell },
      { Header: "date", accessor: "date", Cell: wrapWordCell },
      { Header: "home", accessor: "home", width: "100" },
      { Header: "away", accessor: "away", width: "100" },
      { Header: "markets", accessor: "markets", Cell: marketsCellRender, width: "80px" },
      {
        Header: "Match Result",
        accessor: "matchresult",
        Cell: matchResultCellRender,
        width: "240px",
      },
      { Header: "action", accessor: "action", width: "100px" },
    ],

    rows: [],
  });

  const css = globalCss ? globalCss.default : null;
  const customColors = css.customColors;

  
  let navigate = useNavigate();
  
  async function initData() {
    loading = true;
    //console.log("tab Opened, Init Data: ");
    //console.log(rowData.eventType, rowData.competitionId, rowData.sport);

    let platformId = userData.defaultPlatform.value;

    let getOddsEndpoint = `/api/v1/keys/${platformId}/fixtures/${rowData.eventType}/${rowData.sport}/${rowData.id}`;
    if (rowData.provider_id) {
      getOddsEndpoint = getOddsEndpoint + "/" + rowData.provider_id;
    } else {
      if (rowData.competitionId == rowData.id) getOddsEndpoint = getOddsEndpoint + "/1000";
    }
    let response = await getData(getOddsEndpoint, {
      Authorization: getAuthorizationHeader(),
    });
    if (response != null) {
      //const data = createFixtures(response.data);
      //setDataTableData(data);
      formatData(response.data);
    } else {
      formatData([]);
    }
  }

  async function formatData(fixtures) {
    rowData.fixturesCount = fixtures.length;
    setFixtures({ columns: [], rows: [] });

    setFixtures(createFixtures(fixtures));

    if (open == false) setOpen(!open);
    loading = false;
  }

  function createFixtures(fixtures) {
    const data = {
      columns: [
        { Header: "provider", accessor: "provider_id", width: "20", Cell: providerCellRender },
        { Header: "id", accessor: "fixtureId" },
        { Header: "competition", accessor: "league", Cell: wrapWordCell },
        { Header: "date", accessor: "date", Cell: wrapWordCell },
        { Header: "home", accessor: "home", width: "100" },
        { Header: "away", accessor: "away", width: "100" },
        { Header: "markets", accessor: "markets", Cell: marketsCellRender, width: "80px" },
        {
          Header: "Match Result",
          accessor: "matchresult",
          Cell: matchResultCellRender,
          width: "240px",
        },
        { Header: "action", accessor: "action", Cell: fixtureActions, width: "100px" },
      ],

      rows: [],
    };

    for (let index = 0; index < fixtures.length; index++) {
      try {
        const fixture = fixtures[index];
        if (fixture) {
          let dt = new Date(fixture.fixture.startDate).toLocaleString("en-GB");
          //let matchResultMarket = fixture.markets.find((item) => item.type === "match_result");
          let matchResultMarket = null;

          data.rows.push(
            createFixtureData(
              fixture.fixture.eventId,
              fixture.provider_id,
              fixture.fixture.sport.id,
              fixture.fixture.region.providerName,
              fixture.fixture.competition.providerName,
              rowData.eventType,
              dt,
              fixture.fixture.participants[0].providerName,
              fixture.fixture.participants[1].providerName,
              fixture.fixture.status,
              fixture.filtered,
              fixture.blocked,
              matchResultMarket
                ? {
                    name: matchResultMarket.name,
                    odds: matchResultMarket.odds,
                  }
                : { name: "", odds: null },
              fixture.markets.filter((item) => item.status !== "deleted"),
              [{ vlcourt: false }, { stats: true }, { timeline: true }, { scoreboard: true }],
              fixture.live,
              fixture.fixture
            )
          );
        }
      } catch (error) {
        console.log(error);
      }
    }

    return data;
  }

  /**
   *
   * @param {*} fixtureId
   * @param {*} provider_id
   * @param {*} sport
   * @param {*} region
   * @param {*} league
   * @param {*} type
   * @param {*} date
   * @param {*} home
   * @param {*} away
   * @param {*} status
   * @param {*} filtered
   * @param {*} blocked
   * @param {*} matchresult
   * @param {*} markets
   * @param {*} products
   * @param {*} live
   * @param {*} fixtureInfo
   * @returns
   */
  function createFixtureData(
    fixtureId: number,
    provider_id: number,
    sport: string,
    region: string,
    league: string,
    type: string,
    date: string,
    home: string,
    away: string,
    status: string,
    filtered: boolean,
    blocked: object,
    matchresult: object,
    markets: array,
    products: array,
    live: object,
    fixtureInfo: object
  ) {
    return {
      fixtureId,
      provider_id,
      sport,
      region,
      league,
      type,
      date,
      home,
      away,
      status,
      filtered,
      blocked,
      matchresult,
      markets,
      products,
      live,
      fixtureInfo,
    };
  }

  function wrapWordCell({ value, ...rest }) {
    let headerName = rest.column.id;
    return <div className={headerName + "-cell"}>{value}</div>;
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  function providerCellRender({ value, ...rest }) {
    let pr = providers.find((p) => p.value == value);

    return (
      <SoftTypography
        variant=""
        style={{
          display: pr.label ? "" : "none",
          fontSize: "0.75rem",
          textShadow: "0px 0px 5px #cececece",
          marginLeft: "20px",
        }}
        sx={{
          backgroundColor: customColors[pr.label],
          borderRadius: "50px",
          minWidth: "75px",
          boxShadow: "0px 0px 1px #ffffffa1",
          padding: "5px 5px 5px 7px",
          color: "#fff",
          textShadow: "0px 0px 2px #000 !important",
        }}
        // className={"provider-" + rowData.provider + "-competition"}
      >
        {"  "}
        {pr.label}
        {"  "}
      </SoftTypography>
    );
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  function marketsCellRender({ value, ...rest }) {
    let marketsLength = value.length;

    return (
      <div className="markets-cell">
        <HtmlTooltip placement="top" title={"Number off all available markets"}>
          <Link
            to="/monitoring/fixture-live-view"
            //target="_blank"
            onClick={(e) => openFixture(e, rest.row.original)}
          >
            {marketsLength}
          </Link>
          {/* <span>{marketsLength ? marketsLength : 0}</span> */}
        </HtmlTooltip>
      </div>
    );
  }

  function fixtureActions({ value, ...rest }) {
    return (
      <ActionCell
        id={rest.row.original.fixtureId}
        filtered={rest.row.original.filtered}
        row={rest.row}
        traderView={traderView}
        handleApplyAction={handleSignals}
      />
    );
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  function matchResultCellRender({ value, ...rest }) {
    const matchResult = value;

    return (
      // <SoftBox display="block" justifyContent="center" alignItems="center" px={3}>
      //   <SoftBox display="flex">
      //     <SoftTypography
      //       style={{
      //         fontSize: "0.85rem",
      //         width: "100%",
      //         textAlign: "center",
      //         backgroundColor: "aliceblue",
      //       }}
      //     >
      //       {matchResult.name}
      //     </SoftTypography>
      //   </SoftBox>
      <SoftBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        px={3}
        className="market-match-result"
      >
        {matchResult.odds ? (
          matchResult.odds.map((odd, index) => {
            return (
              <SoftBox
                key={index + "-" + odd.label}
                display="block"
                lineHeight={0}
                title={odd.previousValue}
                className="odd-holder"
              >
                <SoftBox display="flex">
                  <SoftTypography className="odd-name">{odd.label}</SoftTypography>
                </SoftBox>
                <SoftBox display="flex" lineHeight={0} title={odd.previousValue}>
                  <SoftTypography className={"odd odd-" + odd.status}>
                    {odd.status === "deleted" ? " - " : parseFloat(odd.value).toFixed(2)}
                  </SoftTypography>
                  <SoftBox
                    color={odd.previousValue > odd.value ? "success" : "error"}
                    lineHeight={2}
                    style={{ display: odd.status === "deleted" ? "none" : "" }}
                  >
                    <Icon
                      sx={{ fontWeight: "bold", fontSize: "0.85rem" }}
                      color={odd.previousValue > odd.value ? "success" : "error"}
                    >
                      {odd.previousValue > odd.value ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                    </Icon>
                  </SoftBox>
                  <SoftTypography
                    style={{ display: index == 2 ? "none" : "" }}
                    className="odd-seperator"
                  >
                    |
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            );
          })
        ) : (
          <SoftBox display="block" lineHeight={0} title="No Match Result available this moment">
            <SoftBox display="flex">
              <SoftTypography style={{ fontSize: "0.85rem", color: "red" }}> - </SoftTypography>
            </SoftBox>
          </SoftBox>
        )}
        {/* </SoftBox> */}
      </SoftBox>
    );
  }

  async function handleSignals(e, id, row, filtered, view) {
    e.preventDefault();
    switch (view) {
      case "regular":
        handleBlockUnblockSignal(e, id, row, filtered);
        break;
      case "trader":
        checkTraderAvailability(e, id, row);
        break;
      default:
        break;
    }
  }

  function handleBlockUnblockSignal(e, id, row, filtered) {
    e.preventDefault();
    let provider_id = row.original.provider_id;
    let signal = {
      platform_id: userData.defaultPlatform.value,
      event_id: id,
      provider_id: provider_id,
    };

    Swal.fire({
      title: "We proccess your request! ",
      html: "Wait for few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
        let response = null;
        if (filtered) {
          //console.log("signal TO DELETE to send -> ", signal, filtered);
          let getOddsEndpoint = `/api/v1/fixturefilters/${filtered}`;
          response = await delData(getOddsEndpoint, {
            Authorization: getAuthorizationHeader(),
          });
        } else {
          //console.log("signal TO CREATE to send -> ", signal, filtered);
          let getOddsEndpoint = `/api/v1/fixturefilters/`;
          response = await postData(getOddsEndpoint, signal, {
            Authorization: getAuthorizationHeader(),
          });
        }

        if (!response) {
          Swal.clickDeny();
        } else {
          if (response.status === 200) {
            Swal.clickConfirm();
          }
        }
      },
      willClose: () => {},
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        //console.log("I was closed by the timer");
        //routeChange();
      }

      initData();

      if (result.isConfirmed) {
        Swal.fire("Request Sent!", `Live Data sent to the platform`, "success");
      }
      if (result.isDenied) {
        Swal.fire(
          "Error!",
          `Live Data didn't send to the platform. Please try again later!`,
          "error"
        );
      }
    });
  }

  function openFixture(e, data) {
    e.preventDefault();
    if (data.blocked) return;
    const userData = getUserData();
    const cachedPlatform = userData.defaultPlatform.value;
    var newWindow = window.open(
      `/monitoring/fixture-live-view/?platformId=${cachedPlatform}&providerId=${
        data["provider_id"]
      }&sport=${data.fixtureInfo.sport.name.toLowerCase()}&type=${data.type.toLowerCase()}&competitionId=${
        data.fixtureInfo.competition.providerId
      }&id=${data["fixtureId"]}`
    );
    newWindow.fixture = data;
    //routeChange(`/monitoring/fixture-live-view`, { state: { fixture: rowData }, replace: true });
  }

  function openTraderFixtureView(e, data) {
    e.preventDefault();
    if (data.blocked) return;
    const userData = getUserData();
    const cachedPlatform = userData.defaultPlatform.value;
    var newWindow = window.open(
      `/monitoring/fixture-trader-view/?platformId=${cachedPlatform}&providerId=${data["provider_id"]}&sport=${data["sport_name"]}&type=${data["type"]}&competitionId=${data["competition_id"]}&id=${data["fixture_id"]}`
    );
    newWindow.fixture = data;
    //routeChange(`/monitoring/fixture-live-view`, { state: { fixture: rowData }, replace: true });
  }

  async function checkTraderAvailability(e, id, row) {
    e.preventDefault();
    let provider_id = row.original.provider_id;
    if (provider_id == 1000) return true;
    let signal = {
      eventId: id,
      providerId: provider_id,
    };
    let uni_competition_id = null;
    let uni_event_id = null;

    Swal.fire({
      title: "We proccess your request! ",
      html: "Wait for few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
        let response = null;

        let getOddsEndpoint = `/api/v2/panel/trader/checktraderavailability`;
        response = await postData(getOddsEndpoint, signal, {
          Authorization: getAuthorizationHeader(),
        });

        if (!response) {
          Swal.clickDeny();
        } else {
          if (response.status === 200) {
            if (response.data.uniexist) {
              Swal.clickConfirm();
              uni_competition_id = response.data.uniexist.fixture.competition.id;
              uni_event_id = response.data.uniexist.fixture.id;
            } else {
              Swal.clickDeny();
            }
          }
        }
      },
      willClose: () => {},
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        //console.log("I was closed by the timer");
        //routeChange();
      }

      if (result.isConfirmed) {
        openTraderFixtureView(e, {
          blocked: row.original.blocked,
          provider_id: 1000,
          sport_name: row.original.fixtureInfo.sport.name.toLowerCase(),
          type: row.original.type.toLowerCase(),
          competition_id: uni_competition_id,
          fixture_id: uni_event_id,
        });
      }
      if (result.isDenied) {
        Swal.fire("Warning!", `Sorry! No Trader View is available for this fixture!`, "warning");
      }
    });
  }

  function clickHandler(e) {
    if (open == false) {
      initData();
      setOpen(!open);
    } else {
      setOpen(!open);
    }
  }

  useEffect(() => {
    if (open) initData();
  }, [rowData]);

  useEffect(() => {
    //console.log("forceClose: ", forceClose);
    setOpen(true);
    setOpen(false);
  }, [forceClose]);

  return (
    <React.Fragment>
      <TableRow
        id={rowData.name}
        className={open ? "competition-open" : "competition-closed"}
        sx={{ "& > *": { borderBottom: "unset" } }}
        onClick={(e) => clickHandler(e)}
        title={rowData.name + "-" + rowData.id}
      >
        <TableCell style={{ minWidth: "20px", width: "20px", borderBottom: "unset" }}>
          <IconButton aria-label="expand row" size="small">
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={{ borderBottom: "unset", width: "100%" }} align="left">
          <span
            className={rowData.region.replace(/ /g, "_").toLowerCase() + "-flag flag-round"}
          ></span>
          <span>{rowData.region}</span>
          <span>
            {" - "}
            {rowData.name}
          </span>
          <SoftTypography
            variant="Caption"
            style={{
              display: rowData.provider ? "" : "none",
              fontSize: "0.75rem",

              textShadow: "0px 0px 5px #cececece",
            }}
            sx={{ color: rowData.provider ? customColors[rowData.provider] : "inherit" }}
            // className={"provider-" + rowData.provider + "-competition"}
          >
            {"  "}({rowData.provider})
          </SoftTypography>
        </TableCell>
        <TableCell style={{ borderBottom: "unset", width: "90px" }} align="right">
          {rowData.fixturesCount}
        </TableCell>
        <TableCell align="center" style={{ width: "10px" }}></TableCell>
      </TableRow>
      <TableRow className={open ? "fixture-visible" : "fixture-hidden"}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }} className="region-fixtures-table-holder">
              <Typography variant="h6" gutterBottom component="div">
                Fixtures
              </Typography>
              <Paper style={{ opacity: !loading ? "1" : "0.5" }}>
                <DataTable
                  bodyClassName="settlement-fixtures-list"
                  table={fixtures}
                  selectedsport={1}
                  type={"pregame"}
                  toggle={false}
                  canSearch
                  shadow="lg"
                  autoResetPageDefault={true}
                  autoResetGlobalFilter={true}
                  autoResetSortBy={true}
                  hiddenColumns={["matchresult"]}
                />
              </Paper>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    region: PropTypes.string,
    provider: PropTypes.string,
    provider_id: PropTypes.number,
    eventType: PropTypes.string,
    sport: PropTypes.string,
    competitionId: PropTypes.number,
    fixturesCount: PropTypes.number,
    fixtures: PropTypes.shape({
      columns: PropTypes.array,
      rows: PropTypes.array,
    }),
  }),
  traderView: PropTypes.bool,
  forceClose: PropTypes.string,
};

function areEqual(previousProps, nextProps) {
  return (
    previousProps.rowData === nextProps.rowData &&
    previousProps.traderView === nextProps.traderView &&
    previousProps.forceClose === nextProps.forceClose
  );
}

export default React.memo(Row, areEqual);
